import { render, staticRenderFns } from "./IconCurrencyPoundSolid.vue?vue&type=template&id=174531c5"
import script from "./IconCurrencyPoundSolid.vue?vue&type=script&lang=js"
export * from "./IconCurrencyPoundSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports